import React from 'react';
import { connect } from 'react-redux';
import HarvestAndPlantingMap from '../harvestAndPlanting/HarvestAndPlantingMap';
import { IN_SEASON } from '../../../constants/mapLayerIds';
import { AppState } from '../../../store/types/Store';

const LAYER = IN_SEASON.APPLICATIONS;

interface ApplicationsMapProps {
  crop: string;
  dates: { endDate: number; startDate: number; year: number };
  intervals?: unknown[];
}

export function ApplicationsMap(props: ApplicationsMapProps) {
  return <HarvestAndPlantingMap {...props} />;
}

function mapStateToProps(state: AppState, props: { index: number }) {
  const activeSeason = state.seasons.activeSeasons[props.index];
  const seasonEntry = state.seasons.list?.[activeSeason?.id];
  const liquidData = seasonEntry?.liquidData;
  const liquidLayer = state.layers.list?.[activeSeason?.id]?.[LAYER] as {
    activeSubLayerIds?: string[];
    subLayers?: Record<string, { legend?: unknown[] }>;
  } | undefined;

  if (!liquidData || !liquidLayer) {
    return {
      crop: '',
      dates: { endDate: 0, startDate: 0, year: 0 },
      intervals: [],
    };
  }

  const activeSubLayerId = liquidLayer.activeSubLayerIds?.[props.index] ?? '';
  const splitIndex = activeSubLayerId.indexOf('_');
  const activeEndDate = parseInt(activeSubLayerId.slice(0, splitIndex), 10);
  const activeCrop = activeSubLayerId.slice(splitIndex + 1);
  const activeApp = liquidData.find(
    (application: { crop: string; liquidEndDate: number }) =>
      application.crop === activeCrop &&
      application.liquidEndDate === activeEndDate
  );

  if (!activeApp) {
    return {
      crop: '',
      dates: { endDate: 0, startDate: 0, year: 0 },
      intervals: [],
    };
  }

  const { crop, liquidEndDate, liquidStartDate, liquidYear } = activeApp;
  const dates = {
    endDate: liquidEndDate,
    startDate: liquidStartDate,
    year: liquidYear,
  };
  const subLayer = `${dates.endDate}_${crop}`;

  return {
    crop,
    dates,
    intervals:
      liquidLayer.subLayers?.[subLayer]?.legend,
  };
}

export default connect(mapStateToProps)(ApplicationsMap);
